import React from "react";

const ExperienceGrid = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-4 sm:px-6 py-12">
      <h2 className="text-3xl font-bold mb-6">EXPERIENCES</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-4">
        {/* Большой баннер слева (e1) */}
        <div className="col-span-1 sm:col-span-2 md:col-span-9 row-span-1">
          <img
            src="/e1.png"
            alt="Experience 1"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        {/* Правый верхний (e2) */}
        <div className="col-span-1 sm:col-span-1 md:col-span-3 row-span-1">
          <img
            src="/e2.png"
            alt="Experience 2"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        {/* Нижний левый (e3) */}
        <div className="col-span-1 sm:col-span-1 md:col-span-6 row-span-1">
          <img
            src="/e3.png"
            alt="Experience 3"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>

        {/* Нижний правый (e4) */}
        <div className="col-span-1 sm:col-span-1 md:col-span-6 row-span-1">
          <img
            src="/e4.png"
            alt="Experience 4"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>
      </div>
    </div>
  );
};

export default ExperienceGrid;
